module.exports = __webpack_public_path__ + "static/media/3.b0c65436.png";